import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import {
  IDeleteCompanyJobResponseData,
  IDeleteCompanyJobArgs,
} from "./deleteCompanyJob.schema";
import { ZealApiSuccessResponse } from "@zeal/common";

type SuccessResponse = ZealApiSuccessResponse<IDeleteCompanyJobResponseData>;

export const deleteCompanyJob = (axios: IAxiosInstance) => {
  return async (params: IDeleteCompanyJobArgs) => {
    try {
      const { companyID, jobID } = params;
      const response = await axios.noRetry.delete<SuccessResponse>(
        `/api/company-jobs`,
        { params: { companyID, jobID } }
      );
      return response?.data?.data;
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
};
